export const initialState = {
  surplus: 0,
  templatePayroll: 0,
  templatePayrollPercent: 25,
  fixedEarnedIncome: 0,
  standardTaxRelief: -14000,
  StandardTaxReliefCutOffValue: -20135,
  taxableIncome: 0,
  localTaxes: 0,
  localTaxesPercent: 32,
  stateTax: 0,
  stateTaxCutOfValue: 643100,
  stateTaxPercent: 20,
  payrollTax: 0,
  payrollTaxPercent: 29,
  generalPension: 0,
  generalPensionCutOffValue: 43000,
  generalPensionPercent: 7,
  funeralFees: 0,
  funeralFeesPercent: 1.15,
  reductionOfGeneralPension: 0,
  earnedIncomeTax: 0,
  earnedIncomeTaxCutOffValue: 40149,
  earnedIncomeTaxPercent: 10,
  netProfitPerYear: 0,
  netProfitPerMonth: 0,
  generalPayrollTax: 0,
  generalPayrollTaxPercent: 31.42,
  grossAnnualSalary: 0,
  nonTaxableIncomeLimit: 0,
};

/* 
/// EF ///

Årstäckningsbidrag                  ---> YearsGrossMargin.js
Summa fasta kostnader               ---> FixedCosts.js
Åtgärder                            ---> Measures.js
Överskott före skatter              ---> SurplusBeforeTax.js
Egenavgifter (schablon)             ---> TemplatePayrollTax.js
Fastställd förvärvsinkomst          ---> FixedEarnedIncome.js
Grundavdrag                         ---> StandardTaxRelief.js
Beskattningsbar inkomst             ---> TaxableIncome.js
Kommunalskatt                       ---> LocalTaxes.js
Statlig skatt                       ---> StateTax.js
Egenavgifter                        ---> PayrollTax.js
Allmän pension                      ---> GeneralPension.js
Kyrko och begravningsavgifter       ---> FuneralFees.js
Skattereduktion för allmän pension  ---> ReductionOfGeneralPension.js
Jobbskatteavdrag                    ---> EarnedIncomeTax.js
Årslön (netto)                      ---> NetProfitPerYear.js
Månadslön (netto)                   ---> NetProfitPerMonth.js

/// AB ///

Arbetsgivaravgift                   ---> GeneralPayrollTax.js
Årslön (brutto)                     ---> GrossYearSalary.js

*/
